/**
 * App logger — single place allowed to call console (see .eslintrc overrides).
 * In production, only warn/error are emitted; debug/info are suppressed.
 */

const isDev = typeof import.meta !== 'undefined' && import.meta.env?.DEV;
const isTest = typeof process !== 'undefined' && process.env?.NODE_ENV === 'test';

function write(level, args) {
  if (isTest) return;
  if (!isDev && (level === 'log' || level === 'debug' || level === 'info')) return;
  /* eslint-disable no-console */
  const fn = console[level] || console.log;
  fn.apply(console, args);
  /* eslint-enable no-console */
}

export const log = {
  debug: (...args) => write('debug', args),
  info: (...args) => write('info', args),
  warn: (...args) => write('warn', args),
  error: (...args) => write('error', args),
};

export default log;
